const setUserDataAction = "SET_USER_DATA";
const setCompanyDataAction = "SET_COMPANY_DATA";
export const updateUserPhoneAction = "UPDATE_USER_PHONE";
export const updateUserPhone = (userId, phoneNumber, sessionId) => ({
  type: updateUserPhoneAction,
  payload: { userId, phoneNumber },
  meta: { sessionId },
});

const setUserData = (payload, meta) => ({
  type: setUserDataAction,
  payload,
  meta,
});

const setCompanyData = (payload, meta) => ({
  type: setCompanyDataAction,
  payload,
  meta,
});

export { setUserData, setUserDataAction, setCompanyData, setCompanyDataAction };
